<template>
    <div class="modal-container">
        <div class="modal fade show" :class="{ 'modal-open': isOpen }" aria-modal="true" role="dialog">
            <div class="modal-overlay" @click="isOpen = false"></div>
            <div class="modal-dialog" :class="[{ 'modal-xxl': xxl, 'modal-xl': xl }, { 'modal-fullscreen-xxl-down': fullscreen }]">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            <slot name="title"></slot>
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                            @click="isOpen = false">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-show="loading"
                            style="position: relative; min-height: 150px; display: flex; justify-content: center; align-items: center;">
                            <span class="loader"></span>
                        </div>
                        <div v-show="!loading">
                            <slot name="body"></slot>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <slot name="footer"></slot>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: 'Title'
        },
        xl: {
            type: Boolean,
            default: false
        },
        xxl: {
            type: Boolean,
            default: false
        },
        fullscreen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isOpen: false,
            loading: false
        };
    },
    methods: {
        open() {
            this.isOpen = true;
        },
        close() {
            this.isOpen = false;
        }
    },
    watch: {
        isOpen: function (val) {
            this.$emit('changeOpen', val);
            if (val)
                document.body.style.overflow = 'hidden';
            else
                document.body.style.overflow = 'auto';
        }
    }
};
</script>

<style scoped>
.modal-open {
    display: block;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--bs-gray-900);
    opacity: .7;
}

/* .modal-body {
    max-height: calc(100vh - 200px);
    overflow-y: auto;
} */

.modal-xxl {
    max-width: 96vw;
}
.loader {
  width: 48px;
  height: 48px;
  border: 5px solid var(--bs-primary);
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  position: relative;
  animation: pulse 1s linear infinite;
}
.loader:after {
  content: '';
  position: absolute;
  width: 48px;
  height: 48px;
  border: 5px solid var(--bs-primary);;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  animation: scaleUp 1s linear infinite;
}

@keyframes scaleUp {
  0% { transform: translate(-50%, -50%) scale(0) }
  60% , 100% { transform: translate(-50%, -50%)  scale(1)}
}
@keyframes pulse {
  0% , 60% , 100%{ transform:  scale(1) }
  80% { transform:  scale(1.2)}
}

@media (max-width: 1400px) {
    .modal-xxl.modal-fullscreen-xxl-down {
        max-width: none;
    }
}
</style>